// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
//import Vue from 'vue'
import Vue from 'vue/dist/vue.js';
import VueRouter from 'vue-router'
import BootstrapVue from 'bootstrap-vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'

import App from './App'
import Home from './pages/Home'
import Page1 from './pages/Page1'
import Page2 from './pages/Page2'
import Page3 from './pages/Page3'
import Page4 from './pages/Page4'
import Page5 from './pages/Page5'
import Page6 from './pages/Page6'
import Page7 from './pages/Page7'
import Page8 from './pages/Page8'
import Page9 from './pages/Page9'
import Page10 from './pages/Page10'
import Resultado1 from './pages/Resultado1'
import Resultado2 from './pages/Resultado2'
import Cadastre from './pages/Cadastre'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(VueRouter)
Vue.use(BootstrapVue)
Vue.use(VueReCaptcha, { siteKey: '<site key>' })

export const bus = new Vue();

const router = new VueRouter({
  routes: [
    { path: '/cadastre', component: Cadastre },
    { path: '/page1', component: Page1 },
    { path: '/page2', component: Page2 },
    { path: '/page3', component: Page3 },
    { path: '/page4', component: Page4 },
    { path: '/page5', component: Page5 },
    { path: '/page6', component: Page6 },
    { path: '/page7', component: Page7 },
    { path: '/page8', component: Page8 },
    { path: '/page9', component: Page9 },
    { path: '/page10', component: Page10 },
    { path: '/resultado1', component: Resultado1 },
    { path: '/resultado2', component: Resultado2 },
    //{ path: '/', redirect: '/page1' }
    { path: '/', component: Home }
  ]
})

/* eslint-disable no-new */
new Vue({
  router,
  el: '#app',
  data: {
    count: 1
  },
  render: h => h(App)
})
